import { useTranslation } from 'react-i18next'

import { DatePickerTag } from '../../DateTime'

function FilterDate({ label, ...restProps }) {
  const { t } = useTranslation()

  return (
    <DatePickerTag
      {...restProps}
      controlProps={{
        ...restProps.controlProps,
        label: t(label),
      }}
    />
  )
}

export default FilterDate
